/**
 * ============================================================
 * App.tsx - 路由配置
 * ============================================================
 * 所有页面路由定义：
 *   - /login          登录页（公开）
 *   - /report         结算报表（所有登录用户）
 *   - /wage-declaration 工资提报（管理员/财务）
 *   - /brokers        经纪人管理（管理员）
 *   - /formulas       公式配置（管理员）
 *   - /import         数据导入（管理员）
 *   - /users          用户管理（管理员）
 *   - /report-template 账单模板（管理员）
 *   - /roles          角色管理（管理员）
 *   - /bills          账单管理（管理员）
 * ============================================================
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth';
import { AuthGuard } from './components/Layout';

// 页面组件导入
import Login from './pages/Login';
import Report from './pages/Report';
import WageDeclaration from './pages/WageDeclaration';
import Brokers from './pages/Brokers';
import Formulas from './pages/Formulas';
import ImportData from './pages/ImportData';
import Users from './pages/Users';
import ReportTemplatePage from './pages/ReportTemplate';
import Roles from './pages/Roles';
import Bills from './pages/Bills';
import Profile from './pages/Profile';
import RoleRedirect from './components/RoleRedirect';

function App() {
  return (
    <AuthProvider>
      <Routes>
          {/* 公开页面 - 登录 */}
          <Route path="/login" element={<Login />} />

          {/* 所有登录用户可访问 */}
          <Route path="/report" element={<AuthGuard page="report"><Report /></AuthGuard>} />
          <Route path="/wage-declaration" element={<AuthGuard page="bills"><WageDeclaration /></AuthGuard>} />
          <Route path="/profile" element={<AuthGuard><Profile /></AuthGuard>} />

          {/* 管理员和财务专用页面 */}
          <Route path="/brokers" element={<AuthGuard adminOnly page="brokers"><Brokers /></AuthGuard>} />
          <Route path="/formulas" element={<AuthGuard adminOnly page="formulas"><Formulas /></AuthGuard>} />
          <Route path="/import" element={<AuthGuard adminOnly page="import"><ImportData /></AuthGuard>} />
          <Route path="/users" element={<AuthGuard adminOnly page="users"><Users /></AuthGuard>} />
          <Route path="/report-template" element={<AuthGuard adminOnly page="report"><ReportTemplatePage /></AuthGuard>} />
          <Route path="/roles" element={<AuthGuard adminOnly page="roles"><Roles /></AuthGuard>} />
          <Route path="/bills" element={<AuthGuard page="bills"><Bills /></AuthGuard>} />

          {/* 默认路由 - 根据角色重定向 */}
          <Route path="/" element={<AuthGuard><RoleRedirect /></AuthGuard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </AuthProvider>
  );
}

export default App;
